import { render, staticRenderFns } from "./PurchasesAverageCheck.vue?vue&type=template&id=5e7199b6"
import script from "./PurchasesAverageCheck.vue?vue&type=script&lang=js"
export * from "./PurchasesAverageCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports